import { Card, CardContent } from "@components/ui/Card";
import { Skeleton } from "@components/ui/Skeleton";

const FlightListSkeleton = ({ groups = 2, cardsPerGroup = 2 }) => {
  const groupItems = Array.from({ length: groups });
  const cardItems = Array.from({ length: cardsPerGroup });

  return (
    <div className="space-y-6">
      {groupItems.map((_, groupIndex) => (
        <div key={groupIndex}>
          <div className="flex items-center justify-between mb-3">
            <Skeleton className="h-6 w-28 !rounded-full" />
            <Skeleton className="h-6 w-24 !rounded-full" />
          </div>

          <div>
            {cardItems.map((__, cardIndex) => (
              <Card
                key={`${groupIndex}-${cardIndex}`}
                className="overflow-hidden mb-3 !rounded-3xl"
              >
                <CardContent className="p-4 space-y-3">
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-40 !rounded-full" />
                    <div className="flex items-center justify-between">
                      <Skeleton className="h-6 w-24 !rounded-full" />
                      <Skeleton className="h-6 w-20 !rounded-full" />
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Skeleton className="h-7 w-20 !rounded-full" />
                      <Skeleton className="h-5 w-5 !rounded-full" />
                      <Skeleton className="h-7 w-20 !rounded-full" />
                    </div>
                    <div className="flex items-center gap-3">
                      <Skeleton className="h-5 w-16 !rounded-full" />
                      <Skeleton className="h-5 w-12 !rounded-full" />
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FlightListSkeleton;
